<template>
  <MarkdownContent :content="content" />
</template>

<script setup>
import MarkdownContent from './MarkdownContent.vue'

defineProps({
  content: { type: String, default: '' },
  // Streaming flag is accepted for API compatibility but no longer affects
  // rendering — markdown renders the same whether mid-stream or finalized.
  streaming: { type: Boolean, default: false },
})
</script>
